export enum DocumentEngagementType {
    Draft = 1,
    Submitted = 2,
}
